var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6431 6.67839L10.8306 9.10527L11.6875 12.7346C11.7347 12.9317 11.7226 13.1383 11.6525 13.3284C11.5824 13.5185 11.4575 13.6836 11.2937 13.8027C11.1298 13.9219 10.9343 13.9899 10.7319 13.998C10.5294 14.0061 10.3291 13.9541 10.1562 13.8484L6.99996 11.9059L3.84184 13.8484C3.66898 13.9534 3.4689 14.005 3.2668 13.9966C3.06469 13.9882 2.8696 13.9201 2.70609 13.801C2.54257 13.682 2.41795 13.5172 2.3479 13.3274C2.27786 13.1376 2.26553 12.9314 2.31246 12.7346L3.17246 9.10527L0.359961 6.67839C0.207022 6.54621 0.0964141 6.3719 0.0419501 6.17723C-0.0125139 5.98256 -0.00842004 5.77616 0.0537205 5.58381C0.115861 5.39145 0.233294 5.22167 0.391354 5.09565C0.549414 4.96964 0.741096 4.89299 0.942461 4.87527L4.62996 4.57776L6.05246 1.13526C6.12946 0.947651 6.26051 0.78717 6.42894 0.674226C6.59738 0.561282 6.7956 0.500977 6.9984 0.500977C7.2012 0.500977 7.39942 0.561282 7.56785 0.674226C7.73629 0.78717 7.86734 0.947651 7.94434 1.13526L9.36621 4.57776L13.0537 4.87527C13.2555 4.89233 13.4477 4.96856 13.6064 5.09439C13.765 5.22023 13.883 5.39009 13.9455 5.58267C14.008 5.77526 14.0123 5.98202 13.9579 6.17705C13.9034 6.37207 13.7926 6.54669 13.6393 6.67902L13.6431 6.67839Z",
    fill: "#F6A704"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.dea066959ed7388b5428e644a7ff90d9.svg";
export { ForwardRef as ReactComponent };